<template>
  <b-list-group>
    <b-list-group-item v-for="label in Object.keys(mapping)" :key="label">
      {{label}} <treeselect :class="{ 'treeselect-error' : fErr('tag_id') }"
            :placeholder="$t('label_set_tag.placeholders.tag_id')"
            :load-options="autocompleteTag" :async="true" :defaultOptions="true"
            v-model="mapping[label]"/>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import { mapGetters, mapState } from 'vuex';

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  mounted() {
    // this.load();
  },
  data() {
    return {
      // config: this.value,
      mapping: {},
    };
  },
  props: {
    modelLabels: {
      type: Array,
      default() { return []; },
    },
    // value: {
    //   type: Object,
    //   default() {
    //     return { labels: [] };
    //   },
    // },
  },
  components: {
    Treeselect
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },

  },
  watch: {
    modelLabels(value) {
      const labels = [...new Set(value || [])]; // unique
      this.mapping = labels.reduce((m, l) => { m[l] = null; return m; }, {});
    },
    mapping: {
      deep: true,
      handler(value) {
        this.$emit('updated', value);
      }
    }

  },
  methods: {

    autocompleteTag({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.tags.list({ notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name}`,
          }));
          callback(null, options);
        });
      }
    },

  }
};
</script>

<style scoped>
</style>
